export const convertSeconds = (seconds: number): string => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = Math.floor(seconds % 60);

    const hourString = hours > 0 ? `${hours}h}` : "";
    const minuteString = minutes > 0 ? `${minutes}m` : "";
    const secondString = remainingSeconds > 0 ? `${remainingSeconds}s` : "";

    if (hours > 0) {
        return `${hourString} ${minuteString || "0m"} ${
            secondString && `${secondString}`
        }`;
    } else if (!hours && minutes > 0) {
        return `${minuteString} ${secondString && `${secondString}`}`;
    }

    return secondString;
};
